import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { authService } from '../services/authService';

const AuthenticatedLayout = ({ children, title, subtitle }) => {
  const { currentUser, userProfile, isAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleLogout = async () => {
    await authService.logout();
    navigate('/login');
  };

  const handleNavigate = (path) => {
    navigate(path);
    setDrawerOpen(false);
  };

  const isActive = (path) => location.pathname === path;

  const displayName = userProfile?.nombre || currentUser?.displayName || currentUser?.email?.split('@')[0] || 'Usuario';
  const displayRole = userProfile?.rol ? (userProfile.rol.charAt(0).toUpperCase() + userProfile.rol.slice(1)) : 'Empleado';
  const initialLetter = displayName.charAt(0).toUpperCase();

  return (
    <div className="app">
      <main className="main">
        <div className="topbar">
          <button className="hamburger-btn" onClick={() => setDrawerOpen(true)} title="Abrir menú" aria-label="Abrir menú">
            <i className="fa-solid fa-bars"></i>
          </button>
          <div className="topbar-info">
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </div>
          <div className="profile-box">
            <div className="profile-avatar">
              {initialLetter}
            </div>
            <div className="profile-text">
              <h3>{displayName}</h3>
              <p>{displayRole}</p>
            </div>
          </div>
        </div>
        <div className="content">{children}</div>
      </main>

      {/* Overlay para el drawer */}
      <div className={`drawer-overlay ${drawerOpen ? 'open' : ''}`} onClick={() => setDrawerOpen(false)}></div>

      {/* Drawer lateral */}
      <div className={`drawer ${drawerOpen ? 'open' : ''}`}>
        <div className="drawer-header">
          <div className="logo" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <img src="/app-icon.png" alt="Comarsa" style={{ width: '28px', height: '28px', borderRadius: '6px', objectFit: 'cover' }} />
            <span>Comarsa</span>
          </div>
          <button className="drawer-close" onClick={() => setDrawerOpen(false)} title="Cerrar menú">
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <nav className="drawer-menu">
          <span className="menu-separator">NAVEGACIÓN</span>
          <button
            className={`drawer-item ${isActive('/') ? 'active' : ''}`}
            onClick={() => handleNavigate('/')}
          >
            <i className="fa-solid fa-house"></i>
            <span>Inicio</span>
          </button>
          {isAdmin && (
            <button
              className={`drawer-item ${isActive('/admin') ? 'active' : ''}`}
              onClick={() => handleNavigate('/admin')}
            >
              <i className="fa-solid fa-user-shield"></i>
              <span>Panel Admin</span>
            </button>
          )}
          <button className="drawer-item logout-item" onClick={handleLogout}>
            <i className="fa-solid fa-right-from-bracket"></i>
            <span>Cerrar sesión</span>
          </button>
        </nav>
      </div>

      {/* Bottom Navigation */}
      <nav className="bottom-nav">
        <button
          className={`bottom-nav-item ${isActive('/') ? 'active' : ''}`}
          onClick={() => handleNavigate('/')}
        >
          <i className="fa-solid fa-house"></i>
          <span>Inicio</span>
        </button>
        {isAdmin && (
          <button
            className={`bottom-nav-item ${isActive('/admin') ? 'active' : ''}`}
            onClick={() => handleNavigate('/admin')}
          >
            <i className="fa-solid fa-user-shield"></i>
            <span>Admin</span>
          </button>
        )}
        <button className="bottom-nav-item" onClick={handleLogout}>
          <i className="fa-solid fa-right-from-bracket"></i>
          <span>Salir</span>
        </button>
      </nav>
    </div>
  );
};

export default AuthenticatedLayout;